export const subtitles = {
    "1": {
        "startTime": 1.5,
        "endTime": 7.0,
        "transcript": "Up'nerkangaqan, tamatum tungiinun qanqatalriakuk.",
        "translation": "When spring starts, we're going to talk about that."
    },
    "2": {
        "startTime": 9.0,
        "endTime": 19.0,
        "transcript": "Waten au͡gkut aquicirugaat pellugaqata waten up'nerkangaqan",
        "translation": "When those playful times are over when spring starts like this"
    },
    "3": {
        "startTime": 20.3,
        "endTime": 28.0,
        "transcript": "Tau͡ga-i waten wanigga eglertaqelriit, imkut eglertaqelriit imkut yuut au͡gkut",
        "translation": "Those who were going to travel like this, those people long ago who were going to travel"
    },
    "4": {
        "startTime": 32.0,
        "endTime": 44.0,
        "transcript": "Tua ciuqliuluku una wangkuta piciryarallernarput ayagyugarni qayangeksailngurni",
        "translation": "This was our first tradition for the young ones who did not have kayaks yet"
    },
    "5": {
        "startTime": 45.8,
        "endTime": 51.5,
        "transcript": "Tan'gurraullemteńi ayuqluteng makut-llu kevgarat-llu",
        "translation": "When we were boys, they were the same as these helpers"
    },
    "6": {
        "startTime": 54.8,
        "endTime": 65.0,
        "transcript": "Waten tua [elliraat-ll'] tau͡ga-i imkut aquiceteng cali atutung'e'rmegteki",
        "translation": "Even though [the orphans] also played"
    },
    "7": {
        "startTime": 65.1,
        "endTime": 76.0,
        "transcript": "Uum nalliini aquiciqtukteng atunge'rmegteki, tau͡gaam ak'anun atuyuunaki.",
        "translation": "Even though they played during this time, they didn't for a long time."
    },
    "8": {
        "startTime": 77.3,
        "endTime": 87.5,
        "transcript": "Uum wanigga, waten wanigga anrutaicetqanemta piluta.",
        "translation": "This, being hungry like this, made us [return home]."
    },
    "9": {
        "startTime": 89.9,
        "endTime": 96.0,
        "transcript": "Tua-ll' wanigga maani mikelngurni wangkuta",
        "translation": "And then we children here"
    },
    "10": {
        "startTime": 97.0,
        "endTime": 108.0,
        "transcript": "Una wani angungnaqtulit iliit nayirmeng-llu pitqeraqan cakneq tengruqapiggluta tengrutullrulriakut",
        "translation": "When one of these hunters happened to catch ringed seals we would be extremely excited"
    },
    "11": {
        "startTime": 109.0,
        "endTime": 113.0,
        "transcript": "Una wanigg' aqsiqallerkaput pitekluku.",
        "translation": "Because we would be full for a time."
    },
    "12": {
        "startTime": 114.5,
        "endTime": 123.5,
        "transcript": "Tau͡gaam qasgim iluanun tamaavet qaneryarameng niisvigmun quyurrluta pituukut.",
        "translation": "However, we would gather there in the community house where we would listen to traditional wisdom."
    },
    "13": {
        "startTime": 124.0,
        "endTime": 134.0,
        "transcript": "Cali tamakut, tamakut nayirtellriim uum aqsautai qasgimun pituluteng.",
        "translation": "One who caught ringed seals would bring the stomachs to the community house."
    },
    "14": {
        "startTime": 134.8,
        "endTime": 140.7,
        "transcript": "Cali mat'umeng uqnarmeng cali aipangqetuluni tamana.",
        "translation": "That was also accompanied by berries cooked in blood."
    },
    "15": {
        "startTime": 140.8,
        "endTime": 150.5,
        "transcript": "Tamaa-i tamana tengrukqapiggluku tua tengruknaurput wangkuta tamalkuqapiaramtamta nunani uitalriani.",
        "translation": "Every one of us in the villages would be extremely excited for that."
    },
    "16": {
        "startTime": 153.4,
        "endTime": 166.0,
        "transcript": "Tau͡ga-i tamaa-i tamana piciryarallrat cali tamakut angussaagtait cameggnek anglanivkenateng cali waten pitullrulriit.",
        "translation": "Another tradition among those hunters was that they did not waste any of their things."
    },
    "17": {
        "startTime": 167.0,
        "endTime": 179.0,
        "transcript": "Angussaagaqamegteki tamakut ukut wani cut'eng nunalgut'teng cali ukut tau͡ga angussaalriatun ayuqluki.",
        "translation": "When they hunted them, it was like they were hunting for their people, their villages."
    },
    "18": {
        "startTime": 180.9,
        "endTime": 192.0,
        "transcript": "Tua-i-ll' imkut ak'a tegganrurtellriit makut arcaqerluteng ayagyugameggneng pingnatutulineng makuneng cingumaigaqut.",
        "translation": "And then those who had become elders especially supported their youth who were trying to make a living."
    },
    "19": {
        "startTime": 193.0,
        "endTime": 196.0,
        "transcript": "Cakneq tau͡ga-i cingumaluki.",
        "translation": "They wholeheartedly supported them."
    },
    "20": {
        "startTime": 197.5,
        "endTime": 204.0,
        "transcript": "Ugg'un caliaqerraarluki uksurpak qaneryaramegteggun tamakut",
        "translation": "After they worked with them all winter with their traditional wisdom"
    },
    "21": {
        "startTime": 205.0,
        "endTime": 215.0,
        "transcript": "Tau͡ga-i cingumapiggluki tau͡g cingumaaqait, cakneq cirliqesqumanricaaqluki tamakut pingnatugtet.",
        "translation": "They would wholehearted support them, not wanting those who were trying to make a living feel defeated."
    },
    "22": {
        "startTime": 216.6,
        "endTime": 229.0,
        "transcript": "Atam, atam imumi wangkuta, wangkuta imumi cillangellemteńi waten maa-i mat'um nalliinitun ayuqellrunritut.",
        "translation": "You see, a long time ago, back when we were growing up, they were not like how it is now."
    },
    "23": {
        "startTime": 229.8,
        "endTime": 233.0,
        "transcript": "Cameng, ca tamalkuan pillrunritaat.",
        "translation": "They didn't have everything available to them."
    },
    "24": {
        "startTime": 233.5,
        "endTime": 243.5,
        "transcript": "Waten-llu unuakuni waten camirrluni pessurnairulluni maketnaqsuunani.",
        "translation": "And in the mornings like this, we would not get up being satisfied [with sleep]."
    },
    "25": {
        "startTime": 246.0,
        "endTime": 257.7,
        "transcript": "Elluatun imumi wangkuta tamaani cameng enuqitenqegcaarallemteńi waten maa-i mat'um nalliinitun ayuqellrunritukut",
        "translation": "Back when we were struggling for food and tools, we were not like how people are now"
    },
    "26": {
        "startTime": 257.8,
        "endTime": 264.0,
        "transcript": "Tau͡gaam naklegnaqluta imumi cillangeqarraallruukut wangkuta cillangellemteńi tamaani.",
        "translation": "But we grew up being pitiful back when we were growing up."
    },
    "27": {
        "startTime": 265.0,
        "endTime": 268.0,
        "transcript": "Aturamteńeng tau͡gaten unakelivkenata.",
        "translation": "We didn't even have a lot of clothes."
    },
    "28": {
        "startTime": 269.3,
        "endTime": 276.5,
        "transcript": "Tau͡gaam ilutequn amlleq au͡galiqluku wangkuta aatailngurni tau͡gaten ayuqellruukut.",
        "translation": "Instead, we who had no fathers carried a lot of sorrow."
    },
    "29": {
        "startTime": 277.5,
        "endTime": 282.5,
        "transcript": "Cakneq umyugarput qacingqavkenaku cumiggluku niiculuta",
        "translation": "We did not succumb to our minds, but were persistent and obedient"
    },
    "30": {
        "startTime": 283.0,
        "endTime": 290.0,
        "transcript": "Qanrutestekamteńeng-llu kepeqluta qaillun elluarrluta anglikumta pillerkamta tungiinun.",
        "translation": "We were in need of teachers for how to do well when we grew up."
    },
    "31": {
        "startTime": 291.0,
        "endTime": 300.3,
        "transcript": "Makutun maa-i tamaani pissuryaraq tau͡gaam keyirmi mat'um angutem pikelqaa.",
        "translation": "Back then, hunting was only for men."
    },
    "32": {
        "startTime": 300.9,
        "endTime": 306.0,
        "transcript": "Qaill' tamakut piculiuluteng pillret cucunarqelriarullruluteng-llu.",
        "translation": "We also wanted to be like those who were somehow good hunters."
    },
    "33": {
        "startTime": 306.5,
        "endTime": 313.0,
        "transcript": "Tau͡gaam capernarqepiggluteng imkut tamaani cillangeqarraallemteńi caperrnarqellruut.",
        "translation": "But the people back then lived very hard lives back when we were growing up."
    },
    "34": {
        "startTime": 314.0,
        "endTime": 324.0,
        "transcript": "Unaken-llu waten angelrianeng imkuneng maklagneng tamakuneng tamana cucukataqluku imkut pitulqaat.",
        "translation": "They also used to envy those big bearded seals down from the ocean."
    },
    "35": {
        "startTime": 324.5,
        "endTime": 333.5,
        "transcript": "Waten imkut teggneret wangkuta qacingqavkarpegnata uksumi pitulqaitkut waten pingnatungvailemta.",
        "translation": "Those elders back then would not have us be lazy in the winter before we made our own living back then."
    },
    "36": {
        "startTime": 334.8,
        "endTime": 345.5,
        "transcript": "Una wani arcaqerluku wanigga waten uksumi qanikciurun una wangkuta tegumiaqelqerput tamaani qaneryarait niilluki.",
        "translation": "Especially in the winter like this, we would always have a shovel obeying their traditional wisdom."
    },
    "37": {
        "startTime": 346.0,
        "endTime": 352.0,
        "transcript": "Tau͡gaam ciunerkamteńun tamaavet elliingnatugluta tamakuneng pitarkamteńeng.",
        "translation": "We only tried to keep putting animals to catch in our future."
    },
    "38": {
        "startTime": 352.3,
        "endTime": 364.0,
        "transcript": "Pissuryuumarinqertellriani umyugarput qacingqavkenaku tau͡gaam makut pekcunailnguut pekcunarcarturluki.",
        "translation": "They would let the minds of those who were on the verge of becoming hunters convince them to live life easy, but they would urge those who were stubborn."
    },
    "39": {
        "startTime": 364.8,
        "endTime": 375.6,
        "transcript": "Waten akingellerkarput-llu umyugaqevkenaku akimeng, tau͡gaam tamaaken neryararkameng akingellerkarput umyugaqluku.",
        "translation": "We also did not think about being paid with money, but thought about how we would be paid with food to eat in the future."
    },
    "40": {
        "startTime": 376.0,
        "endTime": 383.4,
        "transcript": "Atam qessanaqsuituq waten caliuralriani, kitugciuralriani",
        "translation": "You see, it does not make one disinclined when one is hardworking or fixes things"
    },
    "41": {
        "startTime": 383.5,
        "endTime": 390.0,
        "transcript": "Makuneng-ll' amiiget wangkuta pikenrilengramteki allat amiigit ikayurluki cali.",
        "translation": "And even if these doors weren't ours, we would also help with their doors."
    },
    "42": {
        "startTime": 392.0,
        "endTime": 399.0,
        "transcript": "Ca tamalkuan ikayuutekluku allanun wangkuta ilamteńun cuungnaqelriamun pilqerput.",
        "translation": "Everything we did was to help others, those around us, who were trying to survive."
    },
    "43": {
        "startTime": 400.0,
        "endTime": 406.5,
        "transcript": "Tau͡ga umyugaitnun wangkuta waten nalukaniisqumaluta pillerkamta tungiinun.",
        "translation": "We did that so that they would uplift us in their minds."
    },
    "44": {
        "startTime": 407.0,
        "endTime": 409.6,
        "transcript": "Iluumuugaqluni tau͡gaten,",
        "translation": "It would be true,"
    },
    "45": {
        "startTime": 409.8,
        "endTime": 419.0,
        "transcript": "Maa-i-llu wii aturluku cali waten quyaqerlua, kia quyaqercillua kia imum ikayuagaqanga",
        "translation": "I also do that now when I am grateful like this, when someone helps me and makes me grateful"
    },
    "46": {
        "startTime": 420.6,
        "endTime": 429.4,
        "transcript": "Cirlagmun ellinguarucuitaqa, tau͡gaam elluarrluku pillerkaan tungiinun tau͡gaten umyugamkun cingumaaqaqa.",
        "translation": "I do not wish for them to feel defeated, but I push them to do well in my mind."
    },
    "47": {
        "startTime": 429.5,
        "endTime": 439.0,
        "transcript": "Tau͡gatnaluci umyugartualuci caliuratukuvci, una-llu elpeci pingnatugartellerkarci uka-i agiirtuq.",
        "translation": "If you do that, wisely being hardworking, your time to make your own living is well on its way."
    },
    "48": {
        "startTime": 439.8,
        "endTime": 444.0,
        "transcript": "Tua ikayuutekciqaa tamana kia imum umyugalgem.",
        "translation": "That will help whomever is wise."
    },
    "49": {
        "startTime": 444.5,
        "endTime": 456.5,
        "transcript": "Waten makut [agliurturluta]-llu piaqamta, naugga pissulriani tumlliqualuni tumkaitualuni-llu pinarqaqelria, pissurvigkamun ullallerkaa.",
        "translation": "When these people [have sexual relations with girls within a year of their first menstrations], you know, the paths becomes bad for hunters, and there is no path to go to hunting grounds."
    },
    "50": {
        "startTime": 456.7,
        "endTime": 463.8,
        "transcript": "Tua kitugtellriatun tamaaggun kituggluku tamana wangkuta pingnatullerkamta tungii.",
        "translation": "It is as though that is correcting that within us so that we could make our own living."
    },
    "51": {
        "startTime": 464.0,
        "endTime": 472.5,
        "transcript": "Tau͡gaten wangkuta alerquun maliggluku imumi wangkuta tau͡gaten angturriurallruukut qacingqaurpegnata.",
        "translation": "That's how we grew up back then, obeying instructions without succumbing to our mind's desire for an easy life."
    },
    "52": {
        "startTime": 474.0,
        "endTime": 481.5,
        "transcript": "Qacingqauranrilamta tau͡gaten temvut tau͡gaten una ikayuumaluku. Ikayuuluni tau͡gaten pitullruuq.",
        "translation": "Since we did not succumb to our mind's desire, that helped our bodies. That used to be of help."
    },
    "53": {
        "startTime": 482.0,
        "endTime": 491.0,
        "transcript": "Tau͡gaam teyqiquassiyaagaqamta cangnatugaqamta iliini ilutequaqaqluta-llu tau͡gaten pingnatugatullruukut.",
        "translation": "But when we were clumsy when were striving to be hardworking sometimes, we would be emotionally pained as we tried to make a living."
    },
    "54": {
        "startTime": 491.5,
        "endTime": 496.5,
        "transcript": "Maa-i waten aqumgaurluta eglercuitellruukut tamaani.",
        "translation": "We didn't sit like this when we traveled back then."
    },
    "55": {
        "startTime": 497.0,
        "endTime": 506.5,
        "transcript": "Tamaa-i elluatun mat'um nalliini umyugairutuci ayagyugarni. Aqumgaurluci-llu eglercaurcavci.",
        "translation": "These days, you young people are becoming spoiled. It's also because you sit when traveling."
    },
    "56": {
        "startTime": 506.6,
        "endTime": 517.0,
        "transcript": "Qaill' tau͡gaam tayima makut maani angayuqerpeci, aatavci-llu tukautenrilkaci tayima tau͡gaten pingailngatuci tayima ilaci tayima.",
        "translation": "However, if your parents and fathers somehow do not raise you [in the old way] like that, some of you probably will not do that."
    },
    "57": {
        "startTime": 517.5,
        "endTime": 527.5,
        "transcript": "Tamana tau͡gaam nangyariyutekluku pikuvciu nutaan tamakucicetun angayuqerpecicetun tayima ayuqeciqngatuci.",
        "translation": "But if you [are afraid of] that, you may definitely be like your parents."
    },
    "58": {
        "startTime": 528.8,
        "endTime": 534.0,
        "transcript": "Tau͡ga-i au͡ga qanruskiici au͡g'umeng [atu'urkiarulriameng].",
        "translation": "He just told you about what would be useful."
    },
    "59": {
        "startTime": 535.0,
        "endTime": 543.0,
        "transcript": "Tau͡ga aturraarluku waten qanrutkaqaat imkut qantulit ellaita aturraarluku.",
        "translation": "After experiencing it, those teachers would talk about it after using it."
    },
    "60": {
        "startTime": 545.0,
        "endTime": 552.5,
        "transcript": "Maa-i-llu man'a qaneryaraq cali nutarauvkenani. Au͡gaken yaaqvaneng tailriaruluni.",
        "translation": "And this traditional wisdom is not new. It has come from a long time ago."
    },
    "61": {
        "startTime": 554.0,
        "endTime": 561.0,
        "transcript": "Wangkuta-llu maa-i qanengnaqtulini tamakuneng cali maa-i wangkutnun tekilluni.",
        "translation": "And we who try to pass on that traditional wisdom, it has also come to us."
    },
    "62": {
        "startTime": 562.0,
        "endTime": 566.5,
        "transcript": "Yaaqvaneng tailria tamana qaneryaraq man'a.",
        "translation": "That traditional wisdom from a long time ago."
    },
    "63": {
        "startTime": 568.0,
        "endTime": 574.0,
        "transcript": "Una qaneryaraq tau͡ga taigaquq waten au͡gaken yaaqvaneng",
        "translation": "This traditional wisdom comes from a long time ago"
    },
    "64": {
        "startTime": 575.0,
        "endTime": 584.0,
        "transcript": "Tau͡ga-i kitugcilriaruami una qaneryaraq, wangkutni kituggluta, elpeci cali ayagyugarni kituggluci.",
        "translation": "Because this traditional wisdom is for improvement, self improvement for us, and improvement for you young people."
    },
    "65": {
        "startTime": 585.5,
        "endTime": 600.3,
        "transcript": "Tua-i-ll' wanigga nugtarciiqukuk cali kanani pingnatugyaran, qaillun pingnatugyaram tungiinun.",
        "translation": "And so, we will not move to subsisting down in the ocean, how to subsist."
    },
    "66": {
        "startTime": 602.0,
        "endTime": 611.0,
        "transcript": "Qaillun ak'a imkut cassuutait cali, cassuutellengnaarit apertualuki piciqapuk cali.",
        "translation": "We will also point out how their tools worked, their handmade tools."
    },
    "67": {
        "startTime": 612.0,
        "endTime": 616.5,
        "transcript": "Imkut pingnatugaqameng pingnatuuciqlengnaarit.",
        "translation": "The things they used when they subsisted."
    },
    "68": {
        "startTime": 619.0,
        "endTime": 629.0,
        "transcript": "Tua-i-ll' elpeci wanigga niiculriani ukuni ayagyugarni, uumeng ilaqaqatarata:",
        "translation": "And then, you young people who are obedient here, I am going to add this:"
    },
    "69": {
        "startTime": 630.0,
        "endTime": 638.5,
        "transcript": "Qununarqelriaci elpeci ayagyugarluci ayakatarluci, taiqataralriatun yaaken ayuqluci.",
        "translation": "We are reluctant to part with you young people when you're going to travel, as if you are going to come back from over there."
    },
    "70": {
        "startTime": 640.0,
        "endTime": 652.0,
        "transcript": "Tua-i-ll' elpeci eglertarkauguci tau͡gaten, au͡gna tekiteksailkengarci navenrilkurrluku, navegluku pinrilkurrluku.",
        "translation": "And then, you must travel like that, trying not to destroy the future you have yet to come to, trying not to destroy it."
    },
    "71": {
        "startTime": 654.0,
        "endTime": 661.5,
        "transcript": "Waten wanigga ayagyugaam ilii man'a iliini ellmineng navgaquq.",
        "translation": "Some young people here destroy themselves now."
    },
    "72": {
        "startTime": 662.0,
        "endTime": 666.0,
        "transcript": "Kia, kia tau͡gaam navyuitaa cuum, ellmineng tau͡gaam navgaquq.",
        "translation": "No person destroys him, but he destroys himself."
    },
    "73": {
        "startTime": 667.8,
        "endTime": 674.0,
        "transcript": "Au͡gna-llu tekitarkani atuqsailkengani cali ilakluku cali navegluni ellmineng.",
        "translation": "He also destroys himself including his future that he has yet to experience."
    },
    "74": {
        "startTime": 677.3,
        "endTime": 682.5,
        "transcript": "Maa-i tau͡ga-i elpeci man'a anglayuitut amlleringraata.",
        "translation": "For youpl, they are not [fun] even though there are a lot."
    },
    "75": {
        "startTime": 683.5,
        "endTime": 693.0,
        "transcript": "Qaneryararpuk maliggluku cuugukuvci elpeci, qaneryararpuk anglayuitut amlleringraata maa-i mat'um nalliini.",
        "translation": "If youpl¬ want to live according to our2 traditional wisdom, our traditional wisdom [is not fun] even though there are a lot now."
    },
    "76": {
        "startTime": 694.5,
        "endTime": 710.5,
        "transcript": "Atunritqeraqluki atutung'erpeciki iliini aliayuqatukuvci umyugarpeci, umyugarci imangaurkauguq au͡g'umeng atu'urkarpecineng, atungnatugarkarpecineng.",
        "translation": "Even if you do not use them sometimes as you adhere to them, if you get lonely, your minds will be filled with what you must use, what you must strive to use."
    },
    "77": {
        "startTime": 712.5,
        "endTime": 722.5,
        "transcript": "Tau͡gken anglayuun tamalkuan tegumiaqengnaqluku pitukuvciu, cameng unang'ngaituq, umyugarci imang'ngaituq-llu umyugarci.",
        "translation": "However, if you try to hold on to everything fun, you will not gain anything, and your minds will not be filled [with wisdom]."
    },
    "78": {
        "startTime": 723.8,
        "endTime": 743.0,
        "transcript": "Maa-i-am makut maa-i wangkuta pisteput ataci tayima maa-i kanavet ayagaqata tau͡ga cingumaaqekci tayima unangeqaasqumaluki cameng mat'umeng neqkameng.",
        "translation": "Now, when those who help us, your fathers, go down to the ocean, youpl¬ probably hope that they would catch some of this food."
    },
    "79": {
        "startTime": 743.5,
        "endTime": 749.5,
        "transcript": "Maa-i man'a neqkaq enurnaritulria mat'um nalliini, uum nalliini.",
        "translation": "Food becomes scarce these days, these days."
    },
    "80": {
        "startTime": 750.5,
        "endTime": 761.0,
        "transcript": "Tau͡ga-i canairulluni. Iliini-llu tau͡ga aquisciigalingluni.",
        "translation": "You can't do anything anymore. And sometimes, you can't play."
    },
    "81": {
        "startTime": 762.0,
        "endTime": 773.0,
        "transcript": "Cali makut pingnatulriit tukalriit makut arulaiyuunateng tukalriit cali neqkaitenrilnge'rmeng uum nalliini kemgit ilangertetuluteng.",
        "translation": "Also, when these strong hunters, those who are strong without stopping, even though they are not without food these days, they become skinny."
    },
    "82": {
        "startTime": 774.0,
        "endTime": 784.5,
        "transcript": "Tau͡gaam nangengqaluteng irumegteggun caknaaluteng piurallrata mat'um tau͡ga tau͡gaten ayuqlirivkaraqai.",
        "translation": "However, as they were standing on their legs and struggling, they became like that."
    },
    "83": {
        "startTime": 787.8,
        "endTime": 795.5,
        "transcript": "Tau͡ga-ll' tau͡ga tamaani tamaa-i cakviuqapiggluteng tamakut cakviullruut.",
        "translation": "And back then, they would work extremely hard as they struggled."
    },
    "84": {
        "startTime": 797.8,
        "endTime": 806.5,
        "transcript": "Waten-llu nunanun waten ayagaqameng qayateng ellaita eglerulluki.",
        "translation": "And when they traveled to villages like this, they would travel with their kayaks."
    },
    "85": {
        "startTime": 807.5,
        "endTime": 811.0,
        "transcript": "Tamaani-gga tugarpatullrunikiit.",
        "translation": "Back then, they would chisel a lot of ice."
    },
    "86": {
        "startTime": 812.5,
        "endTime": 821.5,
        "transcript": "Ellaita eglerulluki iruteng aturluki pingnatugluteng, waten aqumgaurluteng pivkenateng.",
        "translation": "They would struggle, moving them using their legs, not sitting like this."
    },
    "87": {
        "startTime": 823.3,
        "endTime": 835.0,
        "transcript": "Irumeggnek aturluteng tau͡ga imkut tukatullruluteng tau͡gglainaunrilengraan, qamigarrlainaunrilengraan cuungnatuucimegteggun mat'ukun.",
        "translation": "They would use their legs to push forward, even if it wasn't always that, even if it wasn't only for spring seal hunting, because it was how they survived."
    },
    "88": {
        "startTime": 836.9,
        "endTime": 839.0,
        "transcript": "Atam imumi wangkuk…",
        "translation": "You see, a long time ago, we2…"
    },
    "89": {
        "startTime": 840.9,
        "endTime": 852.0,
        "transcript": "Wangkuta tamaani wangkutneng pissurpailemta tamaani una wani nerangnaqurallerkarput caliaquratulqerput.",
        "translation": "Back then, before we started hunting by ourselves, we would always work on subsistence."
    },
    "90": {
        "startTime": 853.9,
        "endTime": 862.0,
        "transcript": "Imkut qanelriit niilluki tau͡gaten ayuqesqelluta pitullruitkut nerangnaqurallrem tungiinun.",
        "translation": "We would listen to the teachers telling how how we should be concerning subsistence."
    },
    "91": {
        "startTime": 864.0,
        "endTime": 880.0,
        "transcript": "Tau͡ga-i-llu waten pissungaqameng imkut tau͡ga imkut [nangyutkestai] pitarkam tamakut nallunairutaqut tau͡gaten pingnatugaqameng.",
        "translation": "And then when they started hunting, the ones whom the animals were afraid of would be revealed when they subsisted."
    },
    "92": {
        "startTime": 880.2,
        "endTime": 890.5,
        "transcript": "Tau͡gken imkut umyugarteng calivkallrunrilkiit cali tau͡ga qanrutekluteng maaggun ellmeng pissungnatugallermegteggun.",
        "translation": "However, those who did not work on their minds would also be revealed through their subsistence."
    },
    "93": {
        "startTime": 891.3,
        "endTime": 900.3,
        "transcript": "Piyuilkelleq una nunaniqsuituq. Wii-ll' nallunritaqa waten neqkameng unangyuilliqaqama nunaniqsuituq.",
        "translation": "Being incompetent is not enjoyable. I also know that when I cannot catch food, it is not enjoyable."
    },
    "94": {
        "startTime": 904.9,
        "endTime": 911.5,
        "transcript": "Arnamun elliyuitellruut imkut aipangyuitellruut maklagneng-llu unangeqarraarpailegmeng.",
        "translation": "They wouldn't be set up with women, they wouldn't take wives before they first caught bearded seals."
    },
    "95": {
        "startTime": 913.0,
        "endTime": 925.5,
        "transcript": "Tau͡gaam malrurqugnek-llu tau͡ga waten maklagtaqameng, una ayagyugaq malrurqugneng pikevkenaku, tau͡gaam cugnun aruqutekluku, wagg'uq takelmurluku.",
        "translation": "But when they caught bearded seals twice like this, this young person would not keep it twice, but would distribute it among people, takelmurluku as they call it."
    },
    "96": {
        "startTime": 926.0,
        "endTime": 930.0,
        "transcript": "Qecigtuumaan tau͡gaten malrurqugneng tau͡ga piaqluku.",
        "translation": "They would do that twice, including the skin."
    },
    "97": {
        "startTime": 930.8,
        "endTime": 944.5,
        "transcript": "Tuamtellu waten aipangumariaqan, aiparumariluni piaqami, una cali aipaq waten qecigtuumalriameng uqiqunritlerkaa cali nangyanarqellruluni.",
        "translation": "And then when he gets married, they would be afraid that his wife would distribute thin skins."
    },
    "98": {
        "startTime": 945.3,
        "endTime": 964.0,
        "transcript": "Waten-am cali tau͡gaten taukuk malruk pillrungraagneng, aipangkuni-llu tauna aipani maklagmeng tuamtellu, qecigtuumaan tuamtellu tau͡gaten aruqevkaritullruut imkut.",
        "translation": "And even though that had been done with two bearded seals like this, when he takes a wife and catches another bearded seal, they would have them distribute them including the skin."
    },
    "99": {
        "startTime": 964.1,
        "endTime": 969.0,
        "transcript": "Tau͡ga cucunarqelriaruluteng tamakut tamatum nalliini.",
        "translation": "We envied those at that time."
    },
    "100": {
        "startTime": 970.0,
        "endTime": 988.5,
        "transcript": "Tau͡gaam tau͡gaten pikaten pikaryallruameng imkut waten ayuqellruyugnarqut nutelriit ikgetellratni, pitarkaq-llu [au͡gallagpegnani] pitullrungatelliniuq.",
        "translation": "But when they had looked for things for themselves, I think they were like that when guns were scarce, and it seemed that animals to hunt [were not plentiful]."
    },
    "101": {
        "startTime": 988.6,
        "endTime": 999.0,
        "transcript": "Cali maa-i mat'um nalliini imumi imarpiim et'ullra canimetellrani tugaryagluni tau͡ga pitullrulliniuq tamatum nalliini.",
        "translation": "Also, those days, when the ocean's wasn't very deep, they would also chisel the ice at that time."
    },
    "102": {
        "startTime": 1000.8,
        "endTime": 1013.0,
        "transcript": "Maa-i-llu man'a cinaq tayima wangkuta uitayarallput unani imarpiim cińiini cinaqvaraqamta ak'akika kelutmun tayima imarpiim unani iluani ellirtuq.",
        "translation": "And these days, our places where we would stay on the coast when we traveled down to the seashore where the land would be far inland is now down in the ocean."
    },
    "103": {
        "startTime": 1015.9,
        "endTime": 1024.0,
        "transcript": "Waten tayima mile-aq tekilluku kessigingatuq tayima unani uitayarallerput.",
        "translation": "Where we would stay down there is probably a mile out from the shore."
    },
    "104": {
        "startTime": 1025.8,
        "endTime": 1033.0,
        "transcript": "Au͡gani ayuqellrunrituq maa-i mat'um nalliini tamaani wangkuta murilkeqarraallemteńi.",
        "translation": "Back then, it wasn't like how it was now when we first became observant."
    },
    "105": {
        "startTime": 1035.5,
        "endTime": 1043.5,
        "transcript": "Wall'i tau͡ga tamaani waten imkut nutegkun piyuitellermeggni, narulkaquluteng piuratullermeggni",
        "translation": "Or, back when they didn't use guns, when they only harpooned"
    },
    "106": {
        "startTime": 1044.5,
        "endTime": 1058.4,
        "transcript": "Waten mallgungerraarluni ciku ulyuum nalliini waten man'a kiiciqaaraqataraqan imkut nutegkun piyuitellermeggni",
        "translation": "After they would approach the ice during flooding season, when the ice was going to come off back when they didn't use guns"
    },
    "107": {
        "startTime": 1058.5,
        "endTime": 1063.0,
        "transcript": "Tau͡gaam saskumegteggun tau͡ga uqlitumauratullrullinilriit.",
        "translation": "But they would stay ready with their tools."
    },
    "108": {
        "startTime": 1064.0,
        "endTime": 1070.5,
        "transcript": "Tau͡ga-i-llu pivingurautemeggni pugurangaqut imkut unani pitarkait.",
        "translation": "And then as they were set in place, the animals down there would start surfacing."
    },
    "109": {
        "startTime": 1071.5,
        "endTime": 1080.5,
        "transcript": "Tau͡gaam-gguq cali una waten tau͡ga uluryassagaqernauraat uumeng nuqameggneng.",
        "translation": "But, they said that they would try to scare it off like this with their atlatls."
    },
    "110": {
        "startTime": 1080.8,
        "endTime": 1086.0,
        "transcript": "Tau͡ga-i-gguq uluryallagaqan-llu-gguq narulkarpegnaku, pinritnaurtuq.",
        "translation": "They said that when it would be scared away, they wouldn't harpoon it."
    },
    "111": {
        "startTime": 1086.5,
        "endTime": 1092.8,
        "transcript": "Tau͡gaam-gguq tua uluryacaqangraatni pektenrilnguq nutaan tau͡gaten tau͡gaam narulkaraqluku.",
        "translation": "However, they said that one that stayed even when they tried to scare it off, only then would they harpoon it."
    },
    "112": {
        "startTime": 1093.0,
        "endTime": 1095.9,
        "transcript": "Tau͡ga pitullrulliniut tamaani.",
        "translation": "That's what they used to do back then."
    },
    "113": {
        "startTime": 1096.0,
        "endTime": 1102.0,
        "transcript": "Waten-llu-gguq pug'aqameng ungait mermun kucirtaarallrit-ll' alaitnaurtut.",
        "translation": "And they said that when they surfaced like this, they would be able to see water dripping from their whiskers."
    },
    "114": {
        "startTime": 1104.5,
        "endTime": 1115.0,
        "transcript": "Tamatum nalliini tau͡gaam pikateng amllengraata caskuilameng tau͡ga enuqliqaluteng tau͡gaten ilait pitullrulliniut.",
        "translation": "But at that time, even though they had a lot to catch, some of them would be in need because they didn't have tools."
    },
    "115": {
        "startTime": 1117.0,
        "endTime": 1122.0,
        "transcript": "Tau͡gaten tau͡ga pingnatugaqameng tamaani tamakut pingnatulriit",
        "translation": "When those hunters would subsist like that back then"
    },
    "116": {
        "startTime": 1124.0,
        "endTime": 1129.0,
        "transcript": "Tau͡ga nangtequatait amlleqaquq, amlletullrulliniuq.",
        "translation": "They had a lot of suffering, there used to be a lot."
    },
    "117": {
        "startTime": 1131.0,
        "endTime": 1151.0,
        "transcript": "Waten-llu una imkut kaugpiit nakacuit imkut merneng imangqetulit tauna tau͡gaam merteng nang'aqan puqlaku'urluku tauna-am piyarauluni.",
        "translation": "And the walrus bladders that would be filled with water like this, they would have to keep it warm when they had no more water."
    },
    "118": {
        "startTime": 1152.5,
        "endTime": 1162.5,
        "transcript": "Merteng nang'aqan qanikcamun, qanikcameng imirraarluku kem'meggnun qamavet elliluku urugciraqluku.",
        "translation": "When they had no more water, after filling it with snow, they would put it against their flesh inside to thaw it."
    },
    "119": {
        "startTime": 1165.3,
        "endTime": 1174.7,
        "transcript": "Tau͡ga-i tau͡gaten-am tau͡gaam merkangengnaqnaurtut cali man'a qanikcaq urugpailgaku, urungvailgaku.",
        "translation": "That's the only way they would get water before the snow melted."
    },
    "120": {
        "startTime": 1176.0,
        "endTime": 1180.0,
        "transcript": "Nangtequatait amkut, imkut amllertut.",
        "translation": "They had a lot of struggles."
    },
    "121": {
        "startTime": 1181.8,
        "endTime": 1193.0,
        "transcript": "Cali waten pingnatugaqameng tamakut ilait tau͡ga man'a pingnatuuciq ukaqvaarnun taillrulria wangkutnun tekilluni",
        "translation": "Also, when some of them subsisted like this, this subsistence is something that came to us from long ago"
    },
    "122": {
        "startTime": 1193.5,
        "endTime": 1197.0,
        "transcript": "Tau͡gaam makunun tekisnganrituq au͡gna.",
        "translation": "But it hasn't come to these people here."
    },
    "123": {
        "startTime": 1197.9,
        "endTime": 1206.5,
        "transcript": "Talliteng aturluki kanani pingnatutullruluteng, tallimeggneng aturluteng.",
        "translation": "They would use their arms to subsist down in the ocean, using their arms."
    },
    "124": {
        "startTime": 1208.8,
        "endTime": 1227.0,
        "transcript": "Tau͡gaam tamakut anguaruciryaraat tamana anguarutkiuryaraat alerquingatullruluni aipaa uqgellruluku, aipaa-llu angenruluku pitusqelluku.",
        "translation": "But in making their oars, in making what would be their oars, they would be instructed to make one lighter, and the other larger."
    },
    "125": {
        "startTime": 1228.9,
        "endTime": 1233.9,
        "transcript": "Cali tamakut tamaa tegumiaqetukait amlleriluteng.",
        "translation": "The things they would hold would also increase."
    },
    "126": {
        "startTime": 1234.0,
        "endTime": 1243.0,
        "transcript": "Una wanigga legcik cali, legcigmeng pitukiit, tua-i piicunaitqapiaralriaruluni tauna.",
        "translation": "And this gaff, what they call legcik, was essential."
    },
    "127": {
        "startTime": 1245.5,
        "endTime": 1252.5,
        "transcript": "Tau͡ga tau͡gaten piaqameng kanani pikaq tamaani pavingangraan",
        "translation": "When they did that, even though animals were available down in the ocean"
    },
    "128": {
        "startTime": 1254.0,
        "endTime": 1262.9,
        "transcript": "Tau͡ga pavingayaaqengraan tau͡gaam tau͡ga pikaq pavingang'e'rmi piqameng unaknaqsuituq.",
        "translation": "Even though the animals are available, they sometimes do not get any."
    },
    "129": {
        "startTime": 1263.0,
        "endTime": 1266.5,
        "transcript": "Nangtequaqerraarpailegmi unaknaqsuituq kanani.",
        "translation": "You do not catch anything down there without struggling first."
    },
    "130": {
        "startTime": 1268.0,
        "endTime": 1281.5,
        "transcript": "Tau͡ga nangtequaqerraarluni tau͡gaam talligmineng aturraarluni, atuumamarraarluni unakurainatua tau͡ga cuum ilii tau͡gaten pissungnatulriim.",
        "translation": "Only after struggling using his arms, after using them for a long time, some people who subsist catch them."
    },
    "131": {
        "startTime": 1284.5,
        "endTime": 1291.4,
        "transcript": "Tau͡ga-ll' tau͡gaten piaqameng cali una wani qayarteng pirraarluku",
        "translation": "And then when they did that, after taking care of his kayak"
    },
    "132": {
        "startTime": 1291.5,
        "endTime": 1303.7,
        "transcript": "Tuamtellu caknaaluteng, caknaaluteng qayarteng un' pau͡gavet aarnarqenrilngurmun ellingnaqnauraat",
        "translation": "And then they would struggle, struggle to try to put their kayaks inland where it's not dangerous"
    },
    "133": {
        "startTime": 1304.5,
        "endTime": 1308.7,
        "transcript": "Tamakuneng tau͡ga pingnatukengameggneng unangaqameng.",
        "translation": "When they catch those that they hunt."
    },
    "134": {
        "startTime": 1311.0,
        "endTime": 1319.5,
        "transcript": "Nutaan pingnatukengameggneng unakengarteng tauna qayameng nuniinun uitavkarluku.",
        "translation": "Then they would put what they had strove to catch around their kayaks."
    },
    "135": {
        "startTime": 1320.3,
        "endTime": 1326.0,
        "transcript": "Keyimelkuni una-llu tenguan ilii teguluku.",
        "translation": "And if he's alone, it would take some of its liver."
    },
    "136": {
        "startTime": 1327.0,
        "endTime": 1331.7,
        "transcript": "Nunanun ayagluni tau͡ga irugni-am aturlukek aqvaqurluni.",
        "translation": "He would run to the village with his legs."
    },
    "137": {
        "startTime": 1332.0,
        "endTime": 1335.6,
        "transcript": "Tanglurteng tau͡gaam. Tangluicuitellruut.",
        "translation": "But they had snowshoes. They always had snowshoes."
    },
    "138": {
        "startTime": 1337.8,
        "endTime": 1348.0,
        "transcript": "Tau͡ga-ll' nutaan nunat imkut waten anciqut nangermi man'a alarutellrua tua-i tangvagluku.",
        "translation": "And then the villagers would come out like this, watching the one who was appearing on foot."
    },
    "139": {
        "startTime": 1348.5,
        "endTime": 1353.0,
        "transcript": "Cakneq tau͡ga nancuumiitqapiarluteng tamaq'apiarmeng.",
        "translation": "Not one of them wanted to be anywhere else."
    }
};